<div
  class="mobile-alert-overlay"
  *ngIf="state?.open"
  (click)="onBackdrop($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-labelledby]="'mobile-alert-title'"
>
  <div class="mobile-alert-sheet" (click)="$event.stopPropagation()">
    <div class="mobile-alert-icon" [attr.data-tone]="state?.tone || 'info'" *ngIf="!state?.loading">
      <ion-icon [name]="iconName(state?.tone)"></ion-icon>
    </div>

    <div class="mobile-alert-loading" *ngIf="state?.loading">
      <div class="mobile-alert-spinner"></div>
    </div>

    <h2 id="mobile-alert-title" class="mobile-alert-title">{{ state?.title }}</h2>

    <div class="mobile-alert-body" *ngIf="state?.text && !state?.html">
      <p class="mobile-alert-text">{{ state?.text }}</p>
    </div>

    <div
      class="mobile-alert-body mobile-alert-html"
      *ngIf="state?.html"
      [innerHTML]="safeHtml"
    ></div>

    <div class="mobile-alert-input" *ngIf="state?.input && !state?.loading">
      <label *ngIf="state?.inputLabel">{{ state?.inputLabel }}</label>
      <textarea
        *ngIf="state?.input === 'textarea'"
        [(ngModel)]="inputValue"
        [placeholder]="state?.inputPlaceholder || ''"
        rows="3"
      ></textarea>
      <input
        *ngIf="state?.input === 'text'"
        type="text"
        [(ngModel)]="inputValue"
        [placeholder]="state?.inputPlaceholder || ''"
      />
    </div>

    <div class="mobile-alert-actions" *ngIf="!state?.loading">
      <button
        type="button"
        class="mobile-alert-btn mobile-alert-btn--cancel"
        *ngIf="state?.showCancel"
        (click)="onCancel($event)"
      >
        {{ state?.cancelText || 'Annuler' }}
      </button>
      <button
        type="button"
        class="mobile-alert-btn mobile-alert-btn--confirm"
        [attr.data-tone]="state?.confirmTone || 'primary'"
        (click)="onConfirm($event)"
      >
        {{ state?.confirmText || 'OK' }}
      </button>
    </div>
  </div>
</div>
